export enum VideoStatus {
  IDLE,
  CREATING,
  JOINING,
  JOINED,
  LEAVING,
  ERROR,
  HAIRCHECK,
}

export enum VideoFeedType {
  VIDEO = 'video',
  SCREEN_VIDEO = 'screenVideo',
}
